import { Injectable } from '@angular/core';
import { ImageHandler, VideoHandler } from 'ngx-quill-upload';
import * as Quill from 'quill';

Quill.register('modules/imageHandler', ImageHandler);
Quill.register('modules/videoHandler', VideoHandler);

@Injectable()

export class QuillService {

  public minimal = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{'size': ['small', false, 'large']}],

      [{'color': []}, {'background': []}],
      [{'align': []}],

      ['link'],
    ],
  };

  constructor() {
  }

  maxLength(editor: any, length: number): void {
    if (editor.editor.getLength() > length) {
      editor.editor.deleteText(length, editor.editor.getLength());
    }
  }
}
